export default __webpack_public_path__ + "static/media/Icon check.df7d05f4.svg";